export const initialData = {
  nome: ''
};
export default initialData;
